export default "__VITE_ASSET__Ct458C5n__"